import { z } from "zod";

/**
 * globalSegmentationSchema is used to validate the global segmentation
 * for the feature control. It can be one of the following:
 * - "true" (string)
 * - "false" (string)
 * - string (any other string)
 * - undefined
 */
const globalSegmentationSchema = z.union([
  z.literal("true"),
  z.literal("false"),
  z.string(),
  z.undefined(),
]);

/**
 * emailSegmentationSchema is used to validate the email segmentation
 * for the feature control. It can be one of the following:
 * - "email" (string | undefined)
 * - globalSegmentationSchema (any other string)
 * - eligible (array of strings)
 */
const emailSegmentationSchema = z.object({
  key: z.union([z.literal("email"), z.undefined()]),
  global: globalSegmentationSchema,
  eligible: z.array(z.string()).optional(),
});

/**
 * corporateCodeSegmentationSchema is used to validate the corporate code
 * segmentation for the feature control. It can be one of the following:
 * - "corporateCode" (string)
 * - globalSegmentationSchema (any other string)
 * - eligible (array of strings)
 */
const corporateCodeSegmentationSchema = z.object({
  key: z.literal("corporateCode"),
  global: globalSegmentationSchema,
  eligible: z.array(z.string()).optional(),
});

/**
 * FeatureControlPropertiesWithSegmentationSchema is used to validate the
 * feature control properties with segmentation. It can be one of the
 * following:
 * - emailSegmentationSchema
 * - corporateCodeSegmentationSchema
 */
export const FeatureControlPropertiesWithSegmentationSchema = z.union([
  emailSegmentationSchema,
  corporateCodeSegmentationSchema,
]);
